import {
  AfterViewInit,
  Directive,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';

@Directive({
  selector: '[rrInView]',
})
export class InViewDirective implements AfterViewInit {
  alreadyRendered: boolean; // cheking if visible already

  constructor(
    private vcRef: ViewContainerRef,
    private tplRef: TemplateRef<any>,
  ) {}

  ngAfterViewInit() {
    const commentEl = this.vcRef.element.nativeElement; // template
    const elToObserve = commentEl.parentElement;
    this.setMinWidthHeight(elToObserve);

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          this.renderContents(entry.isIntersecting);
        });
      },
      { threshold: [0, 0.1, 0.9, 1] },
    );
    observer.observe(elToObserve);
  }

  public async renderContents(isInView) {
    if (isInView && !this.alreadyRendered) {
      this.vcRef.clear();
      this.vcRef.createEmbeddedView(this.tplRef);
      const videoelement =
        this.vcRef.element.nativeElement.previousElementSibling;
      if (videoelement && videoelement.tagName == 'VIDEO') {
        videoelement.muted = true;
        await videoelement.play().catch(() => {});
      }
      this.alreadyRendered = true;
    }
  }

  setMinWidthHeight(el) {
    // prevent issue being visible all together
    const style = window.getComputedStyle(el);
    const [width, height] = [parseInt(style.width), parseInt(style.height)];
    !width && (el.style.minWidth = '40px');
    !height && (el.style.minHeight = '40px');
  }
}
